import createIcon from '../../createIcon';

/**
 * @component @name Checkroom
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuNTk5OCAxOC4yMDExTDEyLjk5OTggMTEuNzUxMVYxMC44NDExQzE0LjY0OTggMTAuMzUxMSAxNS43OTk4IDguNjcxMTMgMTUuNDI5OCA2Ljc5MTEzQzE1LjE2OTggNS40ODExMyAxNC4xMjk4IDQuMzkxMTMgMTIuODE5OCA0LjA5MTEzQzEwLjUzOTggMy41NzExMyA4LjQ5OTc3IDUuMzAxMTMgOC40OTk3NyA3LjUwMTEzSDEwLjQ5OThDMTAuNDk5OCA2LjY3MTEzIDExLjE2OTggNi4wMDExMyAxMS45OTk4IDYuMDAxMTNDMTIuODI5OCA2LjAwMTEzIDEzLjQ5OTggNi42NzExMyAxMy40OTk4IDcuNTAxMTNDMTMuNDk5OCA4LjM0MTEzIDEyLjgwOTggOS4wMjExMyAxMS45Njk4IDkuMDAxMTNDMTEuNDI5OCA4Ljk5MTEzIDEwLjk5OTggOS40NTExMyAxMC45OTk4IDkuOTkxMTNWMTEuNzUxMUwyLjM5OTc3IDE4LjIwMTFDMS42Mjk3NyAxOC43ODExIDIuMDM5NzcgMjAuMDAxMSAyLjk5OTc3IDIwLjAwMTFIMjAuOTk5OEMyMS45NTk4IDIwLjAwMTEgMjIuMzY5OCAxOC43ODExIDIxLjU5OTggMTguMjAxMVpNNS45OTk3NyAxOC4wMDExTDExLjk5OTggMTMuNTAxMUwxNy45OTk4IDE4LjAwMTFINS45OTk3N1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Checkroom = createIcon('Checkroom', [
  [
    'path',
    {
      d: 'M21.5998 18.2011L12.9998 11.7511V10.8411C14.6498 10.3511 15.7998 8.67113 15.4298 6.79113C15.1698 5.48113 14.1298 4.39113 12.8198 4.09113C10.5398 3.57113 8.49977 5.30113 8.49977 7.50113H10.4998C10.4998 6.67113 11.1698 6.00113 11.9998 6.00113C12.8298 6.00113 13.4998 6.67113 13.4998 7.50113C13.4998 8.34113 12.8098 9.02113 11.9698 9.00113C11.4298 8.99113 10.9998 9.45113 10.9998 9.99113V11.7511L2.39977 18.2011C1.62977 18.7811 2.03977 20.0011 2.99977 20.0011H20.9998C21.9598 20.0011 22.3698 18.7811 21.5998 18.2011ZM5.99977 18.0011L11.9998 13.5011L17.9998 18.0011H5.99977Z',
      key: '10bbl8',
    },
  ],
]);

export default Checkroom;
